import {
  COUNTY,
  DISTRICT,
  SUB_COUNTY,
  PARISH,
  VILLAGE,
} from "../../utils/constants";
import { createSelectItem } from "../../utils/helpers";
import { CountiesForm } from "./useCounties";
import { DistrictsForm } from "./useDistricts";
import { SubCountyForm } from "./useSubCounties";
import { ParishesForm } from "./useParishes";
import { VillagesForm } from "./useVillages";

export const useMasterDataForm = ({ form, updateFormValue, onChange }) => {
  const location_types = [
    ...[DISTRICT, COUNTY, SUB_COUNTY, PARISH, VILLAGE].map((type) =>
      createSelectItem(type),
    ),
  ];

  function getDetailsFields(type: any) {
    switch (type) {
      case DISTRICT:
        return (
          <DistrictsForm
            form={form}
            updateFormValue={updateFormValue}
            onChange={onChange}
          />
        );
      case COUNTY:
        return (
          <CountiesForm
            form={form}
            updateFormValue={updateFormValue}
            onChange={onChange}
          />
        );
      case SUB_COUNTY:
        return (
          <SubCountyForm
            form={form}
            updateFormValue={updateFormValue}
            onChange={onChange}
          />
        );
      case PARISH:
        return (
          <ParishesForm
            form={form}
            updateFormValue={updateFormValue}
            onChange={onChange}
          />
        );
      case VILLAGE:
        return (
          <VillagesForm
            form={form}
            updateFormValue={updateFormValue}
            onChange={onChange}
          />
        );
      default:
        break;
    }
  }
  const sections: any = [
    {
      title: "Location Type",
      fields: [
        {
          field_name: "location_type",
          type: "select",
          props: { required: true },
          options_data: location_types,
        },
      ],
    },
    {
      title: `${form?.location_type} Details`,
      visible:
        Object.keys(form).length > 0 &&
        form?.location_type &&
        typeof form?.location_type === "string",
      component: getDetailsFields(form?.location_type),
    },
  ];

  const redirect = "reload";

  return { sections, redirect };
};
